import { Type } from 'class-transformer';
import { UserDataPersonalContactPhoneModel } from '../../users/user-data.model';
import { StudentContactAttributes } from './student-contact-options.model';

export function StudentContactPhoneModel_ClassTransform_Type() {
	return UserDataPersonalContactPhoneModel;
}

export class StudentContactModel {
	link_id: number;
	name: string;
	@Type(StudentContactPhoneModel_ClassTransform_Type)
	phones: UserDataPersonalContactPhoneModel[];
	emails: string[];
	url: string;
	account_uid?: number;
	attributes: StudentContactAttributes[];
	relationship: string;
}
